export default function MeetBrooke() {
  return (
    <section className="w-full py-16 md:py-20 px-6 md:px-12 lg:px-24 bg-gradient-to-b from-white to-amber-50/30">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-light mb-8" style={{ color: '#1F2937', fontFamily: "'Inter', sans-serif" }}>
          Meet Brooke Emery
        </h2>
        
        {/* Photo Section */}
        <div className="mb-10 flex flex-col items-center">
          <div className="w-full max-w-md mb-6">
            <img 
              src="https://static.readdy.ai/image/28da5b82b62ca95ef0a33638ffb4027e/3b289e25b87f1e357cfa3f0f273a5413.png" 
              alt="Brooke Emery wearing a Goose hat"
              className="w-full h-auto object-cover rounded-lg"
            />
          </div>
          <p className="text-base md:text-lg italic text-center max-w-2xl" style={{ color: '#6B7280', fontFamily: "'Inter', sans-serif", lineHeight: '1.7' }}>
            This photo is here because it reminds me that one of my biggest partnership deals started in a room where someone was wearing a Phish hat. I love Goose, he loved Phish, and that simple human moment opened a real connection. It turned into a close friendship, countless jam band texts, and a collaboration that was both meaningful and very profitable. When partnerships begin this way, they don't just work, they stick. And they're a lot more fun.
          </p>
        </div>
        
        <div className="space-y-6" style={{ lineHeight: '1.8' }}>
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            When she's not taking a stand-up comedy class with her husband, Brooke Emery creates win win partnerships, supports business development, and helps people move ideas into aligned action while doing good in the world.
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            Brooke works best with people who are fun, creative, and consciousness forward. She has a natural ability to see how people, platforms, and possibilities fit together and genuinely loves connecting the right dots. She often refers to her network as her jellybean jar of people.
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            A natural connector and strategic alliance builder, Brooke is often the behind-the-scenes secret weapon for visionaries, best selling authors, and speakers who want meaningful growth without sacrificing integrity. She brings clarity, momentum, and a human, intuitive approach to collaboration.
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            One visionary Brooke supported followed her intuition to invest in a film that later received an Academy Awards nomination, reinforcing her belief that aligned decisions create real-world impact.
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            Forbes has recognized Brooke as a natural connector for her ability to build creatively brilliant networks through genuine relationship building. As she puts it, "I'm the person who talks to you on the airplane. I'm a people collector."
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            She is also the proud mother of two wonderful daughters and believes the strongest partnerships are built on trust, humor, and shared purpose.
          </p>
          
          <p className="text-lg md:text-xl font-light" style={{ color: '#374151', fontFamily: "'Inter', sans-serif" }}>
            You can find Brooke on{' '}
            <a 
              href="https://www.linkedin.com/in/brookeconnect?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
              target="_blank"
              rel="noopener noreferrer"
              className="underline hover:opacity-70 transition-opacity"
              style={{ color: '#D97706' }}
            >
              LinkedIn
            </a>.
          </p>
        </div>
      </div>
    </section>
  );
}
